module.exports = __webpack_public_path__ + "img/ai1.3c7e3649.png";